// The LIVE cache-enable gate: reads the runtime input and delegates the DECISION to
// `decideCacheEnabled` (./should-cache.ts), which stays pure and unit-tested.
//
// Lifted out of state/app.svelte.ts's `cacheOn` (whose body this is) for one reason:
// app.svelte.ts imports the agents plugin state, so the agents plugin cannot import
// app.svelte.ts back — and the agent-timeline / session-work read seams live there
// (CYBORG-987). A second copy of this gate in that module is exactly the kind of
// duplication that drifts, and a cache gate that drifts is a privacy bug. One
// definition, two callers.
//
// The platform arguments this used to pass (iOS / desktop / Android) are gone:
// CYBORG-986 made every surface cache, so the flag is the only input left.

import { decideCacheEnabled } from "./should-cache.js";

export function cacheEnabled(): boolean {
  try {
    // Read the LIVE input — the runtime override (toggle in the field WITHOUT a
    // redeploy, reaching every platform including plain web): localStorage
    // "cyborg7:cache" = "off" force-disables (kill switch), anything else leaves the
    // cache on. The stale-while-revalidate cold render kills the open-channel/DM
    // skeleton, and on a cache MISS the exact prior network-first behavior runs
    // unchanged. The pure decision itself lives in decideCacheEnabled().
    const flag = typeof localStorage !== "undefined" ? localStorage.getItem("cyborg7:cache") : null;
    return decideCacheEnabled({ flag });
  } catch {
    return false;
  }
}
